// extracted by mini-css-extract-plugin
export var dropdownIcon = "_ju-6";
export var imgContainer = "_ju-3";
export var menuIcon = "_ju-5";
export var pillWrapper = "_ju-2";
export var pillsContainer = "_ju-1";
export var subscriptionCard = "_ju-0";
export var subscriptionLogo = "_ju-4";